import React from 'react';

export function SlotTimelineChart({ children }) {
  return <div className="slot-summary-chart">{children}</div>;
}
